import { Button, Flex, Tag, Typography } from "antd"

import utils from "../../../../Utils/utils"

const { Title, Text } = Typography

const QuickLinkItem = ({ icon, title, description, url, isRecommend = false }) => {
  const openSupport = () => window?.Intercom("show")
  const openExternalLink = () => utils.goLink(url, "_blank")
  const handleClick = () => {
    if (url) openExternalLink(url)
    else openSupport()
  }

  return (
    <Flex className="quick_link" gap={12} align="flex-start">
      <Button className="icon" icon={icon} onClick={handleClick} />

      <div className="quick_content" onClick={handleClick}>
        <Flex className="quick_link_head" gap={12} align="center" wrap="wrap">
          <div className="title">{title}</div>
          {isRecommend && <Tag className="step-status step-status--blue">Recommended</Tag>}
        </Flex>

        <Text type="secondary">{description}</Text>
      </div>
    </Flex>
  )
}

export default QuickLinkItem
